import { useMemo } from 'react';
import { css } from '@emotion/react';
import dayjs from 'dayjs';
import { useQuery } from 'react-query';
import { DevicesApi } from '@frontend/api-devices';
import { Icon } from '@frontend/icons';
import { useLocationService } from '@frontend/wam-location-service';
import { theme } from '@frontend/theme';
import { Button, Table } from '@frontend/design-system';

export const DevicesTable = () => {
  const { currentLocation } = useLocationService();
  const { data } = useQuery({
    queryKey: [currentLocation?.phoneTenantId, 'devices', 'wam'],
    queryFn: DevicesApi.listDevices,
  });

  const filteredDevices = useMemo(() => {
    return data?.filter((device) => device.sipDevice.type === 'desk_phone' || device.sipDevice.type === 'softphone');
  }, [data]);

  return (
    <Table
      fullHeight
      data={filteredDevices ?? []}
      hasGlobalSearch
      hasFilterColumns
      manualFilters
      manualFiltersRender={() => <></>}
      tableActions={[
        {
          Icon: () => <Icon name='update' />,
          label: 'Update',
        },
        {
          Icon: () => <Icon name='export' />,
          label: 'Link',
          onClick: () => {
            console.log('Link');
          },
        },
      ]}
      colConfig={[
        {
          Header: 'Name',
          id: 'name',
          accessor: (device) => device.sipDevice.sipProfile?.name ?? '-',
        },
        {
          Header: 'Agent',
          id: 'agent',
          accessor: (device) =>
            device.sipDevice.type === 'softphone'
              ? `Weave Softphone ${!!device.sipDevice.registration ? device.sipDevice.registration?.user_agent : ''}`
              : device.sipDevice.registration?.user_agent ?? '-',
          minWidth: 275,
        },
        {
          Header: 'Region',
          id: 'region',
          accessor: (device) => device.sipDevice.registration?.region ?? '-',
          minWidth: 75,
        },
        {
          Header: 'External IP',
          id: 'externalIP',
          accessor: (device) => device.sipDevice.registration?.addr ?? '-',
          minWidth: 330,
        },
        {
          Header: 'Last Connected',
          id: 'lastConnected',
          minWidth: 160,
          accessor: (device) => dayjs(device.sipDevice.registration?.modified).format('MMM D, YYYY h:mm a') || '-',
        },
        {
          Header: 'Registered',
          id: 'registered',
          accessor: (device) => {
            return (
              <span
                css={css`
                  border-radius: 50%;
                  height: 8px;
                  width: 8px;
                  background-color: ${device.sipDevice.isRegistered ? theme.colors.success : theme.colors.critical};
                `}
              />
            );
          },
        },
        {
          Header: 'SIP Enabled',
          id: 'sipEnabled',
          accessor: (device) => {
            return (
              <span
                css={css`
                  border-radius: 50%;
                  height: 8px;
                  width: 8px;
                  background-color: ${device.sipDevice.sipProfile?.disabled
                    ? theme.colors.critical
                    : theme.colors.success};
                `}
              />
            );
          },
        },
        {
          Header: 'Actions',
          id: 'actions',
          sticky: 'right',
          accessor: (device) => {
            if (device.sipDevice.type === 'softphone') {
              return (
                <Button
                  destructive
                  size='small'
                  onClick={() => {
                    // setDeviceId(device.ID);
                    // setOpenDestroySoftphoneModal(true);
                  }}
                >
                  Destroy
                </Button>
              );
            }

            if (!device.sipDevice.isRegistered) {
              return '';
            }

            return (
              <Button css={{ width: 'fit-content' }} size='small'>
                Resync Device
              </Button>
            );
          },
        },
      ]}
    />
  );
};
